import { useMutation, useQueryClient } from '@tanstack/react-query';
import { eventService } from '@/api/eventService';
import toast from 'react-hot-toast';
import { TOAST_DURATION } from '@/types/constants';
import { AttendeeType } from '@/types/enums';

export const useCheckInAttendee = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      eventId,
      attendeeId,
      attendeeName,
      checkedInByName,
      attendeeType,
    }: {
      eventId: string;
      attendeeId: string;
      attendeeName?: string;
      checkedInByName?: string;
      attendeeType?: AttendeeType.ADULT | AttendeeType.CHILD;
    }) => {
      return eventService.checkInAttendee(eventId, attendeeId, attendeeName, checkedInByName, attendeeType);
    },
    onSuccess: () => {
      // Invalidate queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ['my-events', 'upcoming'] });
      queryClient.invalidateQueries({ queryKey: ['member-events'] });

      toast.success('Successfully checked in!', {
        duration: TOAST_DURATION.DEFAULT,
      });
    },
    onError: (error: unknown) => {
      let errorMessage = 'Failed to check in. Please try again.';

      const err = error as {
        response?: { data?: { error?: { message?: string }; message?: string } };
        message?: string;
      };
      if (err?.response?.data?.error?.message) {
        errorMessage = err.response.data.error.message;
      } else if (err?.response?.data?.message) {
        errorMessage = err.response.data.message;
      } else if (err?.message) {
        errorMessage = err.message;
      }

      toast.error(errorMessage, {
        duration: TOAST_DURATION.DEFAULT,
      });
    },
  });
};
